import { useState, useRef, useEffect } from 'react';

/**
 * Custom hook to animate fade transitions for header (year/month) in MonthlyStepperTopHeader.
 * Returns a fade class and a trigger function to start the animation.
 */
export function useFadeHeaderAnimation(deps: any[] = [], duration: number = 300) {
  const [fadeClass, setFadeClass] = useState('');
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setFadeClass('fade-in');
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setFadeClass('');
    }, duration);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return fadeClass;
}


export default useFadeHeaderAnimation;
